import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { BannerConfig } from '@se-po/shared-data-access-models'

@Injectable({
  providedIn: 'root',
})
export class BannerDisplayService {
  public bannerConfig = new BehaviorSubject({})
  public bannerConfig$ = this.bannerConfig.asObservable()

  changeBannerConfig(bannerConfig: BannerConfig) {
    this.bannerConfig.next(bannerConfig)
  }
}
